<main-content-holder>
  <div *ngIf="inProgress || !dataLoaded" class="full-width">
    <mat-spinner color="primary" diameter="40" class="loading-progress"></mat-spinner>
  </div>

  <div *ngIf="!inProgress" fxLayout="column" class="full-width">
    <h2 class="center-align" i18n="User Profile|Select School title@@user-profile-select-school-title">
      Select School
    </h2>

    <school-select *ngIf="dataLoaded"
                   [roles]="roles"
                   [selectedRegion]="selectedRegion"
                   [selectedGrade]="selectedGrade"
                   [allowGradeSelect]="!gradeSelectDisabled"
                   [showGrade]="!gradeSelectDisabled"
                   [showSchoolType]="false"
                   [requireGradeSelect]="!gradeSelectDisabled"
                   [selectedSchool]="selectedSchool"
                   [clearSchoolAfterSelect]="false"
                   [allowSchoolClear]="true"
                   (regionSelected)="selectedRegion = $event"
                   (gradeSelected)="selectedGrade = $event.grade"
                   (schoolSelected)="schoolSelected($event)"></school-select>

    <div i18n="User Profile|Select School hint@@user-profile-select-school-hint" class="center-align color-green info-block">
      Please select a region first and start typing in your school name (more than two chars). You need to choose one of the available schools from the suggested list.
    </div>

    <div class="center-align cta-block">
      <app-button *ngIf="selectedRegion"
                  label="Cancel"
                  [secondary]="true"
                  i18n-label="General|Cancel action label@@general-cancel-action-label"
                  (clicked)="cancelChange()"></app-button>
      <span *ngIf="selectedRegion" class="btn-spacer"></span>
      <app-button color="primary"
                  label="Save"
                  i18n-label="General|Save action label@@general-save-action-label"
                  [disabled]="!selectedRegion || !selectedSchool"
                  (clicked)="saveSelection()"></app-button>
    </div>
  </div>
</main-content-holder>
